export const getStructures = documents =>
  documents.map(document => document?.structure).join('')

export const getAgreementsIds = agreements =>
  agreements.map(agreement => agreement?.id)
